import { createContext, useContext } from "react"

export const HomeState = createContext({
	gallery: {
		title: null,
		info: {
			total_pictures: null,
			total_size: null
		},
		event_date: null,
		collection_id: null,
		cover: null
	},
	customer: {
		logo: null,
		name: null,
		subdomain: null
	},
	client: {
		name: null
	},
	front: {
		gallery_url: null,
		home_url: null,
		selection_activated: null,
		hash: null,
		download_all: null,
		sel_link_type: null,
		blocked_private_selection_login: null
	},
	// Init the function used to change info inside context
	setHomeState: () => {},
})

export const useHomeState = () => useContext(HomeState)
